import { COL_CRM_CLIENTS, COL_CRM_EVEREST_CLIENTS } from '../config/auth'
import { supabase } from './supabase'

export type CrmClientOption = {
  source: typeof COL_CRM_CLIENTS | typeof COL_CRM_EVEREST_CLIENTS
  id: string
  name: string
}

type CrmClientRow = { id: string; name: string | null }

/** Имя клиента из записи CRM (обычно поле name). */
export function extractCrmClientName(record: CrmClientRow): string {
  const n = typeof record.name === 'string' ? record.name.trim() : ''
  return n || record.id
}

/** Объединённый справочник клиентов CRM (clients + everest_clients). Только для чтения. */
export async function loadCrmClientOptions(): Promise<CrmClientOption[]> {
  if (!supabase) return []
  const out: CrmClientOption[] = []

  try {
    const { data: rows } = await supabase.from(COL_CRM_CLIENTS).select('id, name').order('name')
    for (const r of rows ?? []) {
      out.push({
        source: COL_CRM_CLIENTS,
        id: r.id,
        name: extractCrmClientName(r),
      })
    }
  } catch {
    /* таблицы может не быть или нет прав — пропускаем */
  }

  try {
    const { data: rows } = await supabase
      .from(COL_CRM_EVEREST_CLIENTS)
      .select('id, name')
      .order('name')
    for (const r of rows ?? []) {
      out.push({
        source: COL_CRM_EVEREST_CLIENTS,
        id: r.id,
        name: extractCrmClientName(r),
      })
    }
  } catch {
    /* нет таблицы everest_clients */
  }

  out.sort((a, b) => a.name.localeCompare(b.name, 'ru'))
  return out
}
